<template>
    <div>
        <b-form-group
            label="ID Document Type"
            label-for="documentType"
            :class="{
                'required-field':
                    field.section == 'register-setup-profile' ? false : true,
            }"
        >
            <b-form-select
                v-model="model"
                v-validate="{
                    required:
                        field.section == 'register-setup-profile'
                            ? false
                            : true,
                }"
                class="form-control"
                :options="options"
                :disabled="loading || disabled"
                data-vv-name="document type"
                :class="{
                    'is-invalid': errors.has('document type'),
                }"
            >
                <option slot="first" :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>
<script>
import Dropdown from './Dropdown.vue'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: Dropdown, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                let options=[]
                if(process.env.VUE_APP_COUNTRY == 'Pakistan')
                {
                    options=[
                        {
                            text: 'National ID Card',
                            value: 'id',
                        },
                    ];
                }
                else
                {
                    options=[
                        {
                            text: 'National ID Card',
                            value: 'id',
                        },
                        {
                            text: 'Driving Licence',
                            value: 'licence',
                        },
                        {
                            text: 'Passport',
                            value: 'passport',
                        },
                    ];
                }
                return {
                    isRequired: true,
                    isLocked: true,
                    title: 'Select ID Document Type',
                    label: 'ID Document Type',
                    placeholder: 'Select ID Document Type',
                    options: options,
                    key: 'identityInfo.type',
                }
            },
            required: false,
        },
        dataSegmentId: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            this.$store.commit('updateField', {
                key: 'documentInfo.identity',
                value: {
                    originalFileName: null,
                    fileName: null,
                },
            })
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        this.options = this.field.options
    }, // End of Component > watch
}
</script>
